var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st125{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st124{fill:#FFFFFF;}\n\t.st123{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st122{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.0182,3.0182;}\n\t.st121{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.0359,3.0359;}\n\t.st120{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.0309,3.0309;}\n\t.st119{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.0283,3.0283;}\n\t.st118{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M352.33,342.69H232.1c-19.23,0-34.81-15.59-34.81-34.81V177.31h155.04V342.69z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M347.65,338.01H229.84c-15.37,0-27.87-12.5-27.87-27.87V181.99h145.69"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st123",
    x1: 347.65,
    y1: 338.01,
    x2: 346.15,
    y2: 338.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M343.13,338.01h-113.3c-15.37,0-27.87-12.5-27.87-27.87V185"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st123",
    points: "201.96,183.49 201.96,181.99 203.46,181.99  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st121",
    x1: 206.5,
    y1: 181.99,
    x2: 344.63,
    y2: 181.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st123",
    x1: 346.15,
    y1: 181.99,
    x2: 347.65,
    y2: 181.99
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M181.7,343.87H70.67V176.13h148.74v130.02C219.41,326.98,202.53,343.87,181.7,343.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M75.35,180.8h139.39v127.81c0,16.87-13.72,30.59-30.59,30.59H75.35"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st123",
    x1: 75.35,
    y1: 180.8,
    x2: 76.85,
    y2: 180.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st120",
    x1: 79.88,
    y1: 180.8,
    x2: 211.72,
    y2: 180.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st123",
    points: "213.24,180.8 214.74,180.8 214.74,182.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M214.74,185.33v123.28c0,16.87-13.72,30.59-30.59,30.59H78.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st123",
    x1: 76.85,
    y1: 339.2,
    x2: 75.35,
    y2: 339.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168.37,
    y: 258.33,
    className: "st118",
    width: 39.26,
    height: 3.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st118",
    cx: 184.26,
    cy: 260.2,
    r: 15.43
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound);
export default __webpack_public_path__ + "static/media/ROUND.7fbbdce477387e61c77d46e0f973ab26.svg";
export { ForwardRef as ReactComponent };